module.exports = __webpack_public_path__ + "img/Dr_Rita_El-Khoury_Podiatre.e6738560.png";